import {DialogBody, DialogHeader} from '@cypro/ui/components'
import {hasConfigurationAccess} from '@/modules/auth/permissions'
import {SHORTCUTS} from '@/modules/shortcuts/constants'
import {usePermissions} from '@/shared/hooks/use-permissions'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {formatForDisplay} from '@tanstack/react-hotkeys'
import {useTranslate} from '@tolgee/react'

export function ShortcutsCheatsheetDialog() {
  const {t} = useTranslate('common')
  const {permissions} = usePermissions()
  const canOpenConfiguration = hasConfigurationAccess(permissions)

  const items = Object.entries(SHORTCUTS)
    // Hide shortcuts whose target page the user may not open.
    .filter(([key]) => {
      if (key === 'PRODUCTION') return permissions.has('production.access')
      if (key === 'CONFIGURATION') return canOpenConfiguration
      return true
    })
    .map(([key, value]) => ({
      label: t(`shortcuts.${key.toLocaleLowerCase()}`),
      value: formatForDisplay(value),
    }))

  return (
    <>
      <DialogHeader description={t('shortcuts.cheatsheet.description')}>{t('shortcuts.cheatsheet.title')}</DialogHeader>

      <DialogBody>
        <DataList items={items} orientation="horizontal" itemLabelProps={{minWidth: '60'}} />
      </DialogBody>
    </>
  )
}
